import { useMutation } from '@apollo/client/react';
import useMe from 'utils/hooks/useMe/useMe';
import UPDATE_BALANCE_VISIBILITY_MUTATION from './UpdateBalanceVisibilityMutation.graphql';

const useBalance = () => {
  const { me, loading } = useMe({
    include: { preferences: true, enterprise: true },
    fetchPolicy: 'cache-and-network',
  });

  const hideBalances = !!me?.preferences?.profile?.hideBalances;
  const [updatePreferences] = useMutation(UPDATE_BALANCE_VISIBILITY_MUTATION);

  const toggleBalanceVisibility = () =>
    updatePreferences({
      variables: {
        params: {
          profile: { hideBalances: !hideBalances },
        },
      },
      optimisticResponse: {
        updateUserPreferences: {
          id: me?.preferences?.id,
          __typename: 'Preferences__User',
          profile: {
            id: me?.preferences?.profile?.id,
            __typename: 'Preferences__User__Profile',
            hideBalances: !hideBalances,
          },
        },
      },
    });

  return { loading, hideBalances, balance: me?.enterprise?.balance, toggleBalanceVisibility };
};

export default useBalance;
